import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerManagerImpact: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const { managerImpactRequestHandler } = await import("./mocks/managerImpactRequestHandler.ts");

        runtime.registerRequestHandlers([managerImpactRequestHandler]);
    }
};
